import { Injectable } from '@angular/core';
import { ApiService } from '../../../../core/services/api.service';
import { Observable } from 'rxjs';
import { IFilters, IPagination } from '../../../../modules/authorization/store/types';
import { IInvoice, ISummaryInvoice } from '../../payrolls/store/types';
import { map } from 'rxjs/operators';

@Injectable({
    providedIn: 'root'
})
export class InvoiceService {

    constructor(
        private apiService: ApiService
    ) { }

    public fetchAll(data: IFilters): Observable<IPagination<ISummaryInvoice>> {
        return this.apiService.get('/summary-invoices', data)
            .pipe(
                map(res => {
                    res.results.map((el: ISummaryInvoice) => {
                        el.isOpened = false;
                        return el;
                    });
                    return res;
                })
            );
    }

    public fetchAllFromPayroll(id: string, data: any): Observable<IPagination<IInvoice>> {
        return this.apiService.get(`/payrolls/${id}/invoices`, data);
    }

    public bulkAction(action: string, ids: string[], active?: boolean): Observable<any> {
        return this.apiService.downloadPost(`/summary-invoices/bulk/${action}`, { ids, active });
    }

    public exportInvoicesToCSV(data: any): Observable<any> {
        return this.apiService.downloadGet(`/invoices`, data);
    }
}
